"use client";

import analytics from "../analytics";
import { useHydrated } from "@utils/hooks";
import { useEffect, useRef } from "react";

// used in whitelabel to only load analytics when consent is given via cookiebot
export default function CustomerIOAnalyticsWithConsent() {
  const hydrated = useHydrated();
  const isAnalyticsActive = useRef(false);

  useEffect(() => {
    const write_key = process.env.NEXT_PUBLIC_CIO_PIPELINE_KEY as string;

    const handleCookiebotAccept = (e: any) => {
      const consentedToMarketing = e?.target?.CookieConsent?.consent?.marketing;

      if (consentedToMarketing && !isAnalyticsActive.current) {
        analytics.load({
          writeKey: write_key,
        });
        isAnalyticsActive.current = true;
      } else if (!consentedToMarketing && isAnalyticsActive.current) {
        analytics.reset();
        window.location.reload();
      }
    };

    const handleCookiebotDecline = (e: any) => {
      const cookieConsentChanged = e?.target?.CookieConsent?.changed;
      const consentedToMarketing = e?.target?.CookieConsent?.consent?.marketing;

      if (!consentedToMarketing && isAnalyticsActive.current) {
        analytics.reset();
        window.location.reload();
      }

      if (cookieConsentChanged) {
        window.location.reload();
      }
    };

    if (hydrated) {
      window.addEventListener("CookiebotOnDecline", handleCookiebotDecline);
      window.addEventListener("CookiebotOnAccept", handleCookiebotAccept);
    }

    return () => {
      window.removeEventListener("CookiebotOnDecline", handleCookiebotDecline);
      window.removeEventListener("CookiebotOnAccept", handleCookiebotAccept);
    };
  }, [hydrated]);

  return null;
}
